import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useGetFjPublicJobsQuery } from '../../../../redux/services/fj_jobs.jsx';
import Spinner from '../../../common/spinner/Spinner.jsx';
import { MainTitle } from '../../../common/index.jsx';
import CollapseBlock from '../../../common/blocks/CollapseBlock/CollapseBlock.jsx';
import FjJobsTable from '../../CMSPages/FriJobs/FjJobs/FjJobsPage/FjJobsTable.jsx';
import { routes } from '../../../../utils/helpers/ApiClient.jsx';
import { useNavigate } from 'react-router-dom';
import FormButton from '../../../antd/form/FormButton/FormButton.jsx';
import FormButtonsContainer from '../../../antd/form/FormButtonsContainer/FormButtonsContainer.jsx';
import { useClickOnJobMutation } from '../../../../redux/services/fj_click_stats.jsx';
import { Alert } from 'antd';

const FjJobsPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { data: jobsData, isLoading, refetch } = useGetFjPublicJobsQuery();

  useEffect(() => {
    document.title = t('FRI.jobs');
  }, []); // Runs on mount

  // ClickStats
  const [eventClickOnJob] = useClickOnJobMutation();

  const handleEventClickOnJob = (id) => {
    eventClickOnJob({ fj_job_id: id })
      .unwrap()
      .then(() => {
        navigate(`${routes.friJobsDetail}/${id}`);
      });
  };

  return (
    <>
      <MainTitle title={t('FRI.jobs')} />

      <FormButtonsContainer>
        <FormButton
          onClick={() => {
            navigate(routes.externalPartnerRegistration);
          }}
        >
          {t('Chcem sa stať externým partnerom FRI')}
        </FormButton>
      </FormButtonsContainer>

      <div style={{ marginBottom: 12 }}>
        <Alert
          type="info"
          showIcon
          description={
            <span>
              {t('Ak máte záujem o nejakú ponuku práce je potrebné ')}
              <a href="/cms/fri-jobs/jobs">{t('prejsť do portálu FRI')}</a>.
            </span>
          }
        />
      </div>

      <CollapseBlock title={t('Zoznam aktuálnych pracovných ponúk')}>
        {isLoading ? (
          <Spinner />
        ) : (
          <FjJobsTable
            fromPublic={true}
            filterPanel={false}
            jobsData={jobsData}
            refetch={refetch}
            onDetailClick={handleEventClickOnJob}
          />
        )}
      </CollapseBlock>
    </>
  );
};

export default FjJobsPage;
